import { useTranslation } from '@centric-os/helpers';
import * as yup from 'yup';

export default () => {
  const { translate } = useTranslation();
  const numberTransform = (value: any) => (isNaN(value) ? undefined : value);

  const schema = yup.object().shape({
    id: yup.string().nullable().optional(),
    name: yup
      .string()
      .nullable()
      .test({
        name: 'test-empty-string',
        test(value, ctx) {
          if (value?.startsWith(' ')) {
            return ctx.createError({ message: translate(`errorMessages.startSpace`) });
          }
          return true;
        },
      })
      .required(translate(`errorMessages.required`))
      .max(64, translate(`errorMessages.max`, { count: 64 })),
    information: yup
      .string()
      .nullable()
      .optional()
      .max(100, translate(`errorMessages.max`, { count: 100 })),
    foodlocker: yup.boolean().required(translate('errorMessages.required')),
    address: yup.object().shape({
      address: yup
        .string()
        .nullable()
        .test({
          name: 'test-empty-string',
          test(value, ctx) {
            if (value?.startsWith(' ')) {
              return ctx.createError({ message: translate(`errorMessages.startSpace`) });
            }
            return true;
          },
        })
        .required(translate('errorMessages.required')),
      city: yup
        .string()
        .nullable()
        .test({
          name: 'test-empty-string',
          test(value, ctx) {
            if (value?.startsWith(' ')) {
              return ctx.createError({ message: translate(`errorMessages.startSpace`) });
            }
            return true;
          },
        })
        .required(translate('errorMessages.required')),
      state: yup
        .string()
        .nullable()
        .test({
          name: 'test-empty-string',
          test(value, ctx) {
            if (value?.startsWith(' ')) {
              return ctx.createError({ message: translate(`errorMessages.startSpace`) });
            }
            return true;
          },
        })
        .required(translate('errorMessages.required')),
      zip: yup.string().nullable().required(translate('errorMessages.required')),
      country: yup
        .string()
        .nullable()
        .test({
          name: 'test-empty-string',
          test(value, ctx) {
            if (value?.startsWith(' ')) {
              return ctx.createError({ message: translate(`errorMessages.startSpace`) });
            }
            return true;
          },
        })
        .required(translate('errorMessages.required')),
      coordinates: yup.object().shape({
        latitude: yup
          .number()
          .transform(numberTransform)
          .required(translate('errorMessages.required'))
          .typeError(translate('errorMessages.required')),
        longitude: yup
          .number()
          .transform(numberTransform)
          .required(translate('errorMessages.required'))
          .typeError(translate('errorMessages.required')),
      }),
    }),
  });

  return {
    schema,
  };
};
